import { useState } from "react";
import UserVideoCard from "./VideoCard";
import UserVideoModal from "./VideoModal";
import { Separator } from "@/components/ui/separator";

/**
 * Consumer Training Module Component
 * Displays a module with its media cards
 */
function UserTrainingModule({ moduleData, isLast }) {
    const [showVideoPlayPopup, setShowVideoPlayPopup] = useState(false);
    const [videoId, setVideoId] = useState('');
    const [videoName, setVideoName] = useState('');

    const handleShowVideo = (id, title) => {
        setVideoId(id);
        setVideoName(title);
        setShowVideoPlayPopup(true);
    };

    const handleHideVideo = () => {
        setShowVideoPlayPopup(false);
    };

    if (!moduleData) return null;

    return (
        <>
            <div className="px-4 sm:px-6 py-4 sm:py-6">
                {/* Module Header */}
                <h2 className="text-2xl font-semibold text-foreground mb-6">
                    {moduleData.moduleName}
                </h2>

                {/* Module Videos/Media - 3 cards per row */}
                {moduleData.media && moduleData.media.length > 0 && (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {moduleData.media.map((item, index) => (
                            <UserVideoCard
                                key={index}
                                videoData={item}
                                onVideoClick={handleShowVideo}
                            />
                        ))}
                    </div>
                )}

                {/* Video Modal */}
                {showVideoPlayPopup && (
                    <UserVideoModal
                        open={showVideoPlayPopup}
                        onOpenChange={setShowVideoPlayPopup}
                        videoId={videoId}
                        videoName={videoName}
                        onClose={handleHideVideo}
                    />
                )}
            </div>

            {/* Full-width separator after each section except the last */}
            {!isLast && <Separator />}
        </>
    );
}

export default UserTrainingModule;
